import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import {applyCollectionRowHighlight, applyHighlightFilter, getCollectionHighlightTrProps, getHighlightPkeyFromLocation, syncCollectionFetchPage} from "utilities/avCenterHighlight";

const DISMISSAL_REASONS = [
	{ value: 'duplicate', label: 'Duplicate' },
	{ value: 'test_account', label: 'Test account' },
	{ value: 'not_our_customer', label: 'Not our customer' },
	{ value: 'other', label: 'Other' },
];

const SEARCH_LABEL = 'AV Subscriptions';

export default class StripeAvUnmatched extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Stripe_Av_Unmatched._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.state.linkModal = false;
		this.state.dismissModal = false;
		this.state.activeRow = null;
		this.state.customerSearch = '';
		this.state.searchResults = [];
		this.state.selectedCustomer = null;
		this.state.selectedAvKey = null;
		this.state.linkNotes = '';
		this.state.dismissalReason = '';
		this.state.dismissNotes = '';
		this.state.linkStatusFilter = 'unmatched';
		this.state.actionError = null;
		this.state.searchLoading = false;
		this.searchTimer = null;
		this.state.highlightRow = getHighlightPkeyFromLocation(props.history);
		this.rowRefs = {};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.history?.location?.hash !== this.props.history?.location?.hash) {
			const highlightRow = getHighlightPkeyFromLocation(this.props.history);
			this.setState({highlightRow}, () => this.fetchData());
		}
	}

	fetchData = async (state) => {
		syncCollectionFetchPage(this, state);
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		delete this.state.filter.link_status;
		this.state.filter.link_status_view = this.state.linkStatusFilter;
		const highlightPkey = applyHighlightFilter(this, this.state.filter);
		this.model.filter = this.state.filter;
		this.setState({loading: true, highlightRow: highlightPkey || this.state.highlightRow});
		window.setTimeout(async () => {
			await this.fetchDataActual(state);
			applyCollectionRowHighlight(this);
		}, 100);
	}

	runCustomerSearch = async (filter) => {
		const model = new API.BuildClass(Types.Stripe_Av_Unmatched._name, API.RequestType.READ);
		model.filter = filter;
		return model.submit(null, 'GET_CUSTOMER_SEARCH', true);
	}

	loadSuggestedCustomer = async (row) => {
		if (!row?.suggested_customer) {
			return;
		}
		try {
			const result = await this.runCustomerSearch({
				customer_pkey: row.suggested_customer,
				stripe_email: row.stripe_customer_email || '',
				product_type: row.product_type || '',
				stripe_customer_id: row.stripe_customer_id || '',
			});
			const match = Array.isArray(result) ? result.find(c => Number(c.pkey) === Number(row.suggested_customer)) : null;
			if (match && !this.customerHasStripeConflict(match, row)) {
				this.setState({
					selectedCustomer: match,
					searchResults: [match],
				});
			}
		} catch (err) {
			this.setState({ actionError: err?.message || 'Could not load suggested customer' });
		}
	}

	searchCustomers = (q) => {
		this.setState({ customerSearch: q, actionError: null });
		if (this.searchTimer) {
			clearTimeout(this.searchTimer);
		}
		if (!q || q.length < 2) {
			this.setState({ searchResults: [], searchLoading: false });
			return;
		}
		const row = this.state.activeRow;
		this.setState({ searchLoading: true });
		this.searchTimer = setTimeout(async () => {
			try {
				const result = await this.runCustomerSearch({
					q,
					stripe_email: row?.stripe_customer_email || '',
					product_type: row?.product_type || '',
					stripe_customer_id: row?.stripe_customer_id || '',
				});
				this.setState({ searchResults: result || [], searchLoading: false });
			} catch (err) {
				this.setState({
					searchResults: [],
					searchLoading: false,
					actionError: err?.message || 'Customer search failed',
				});
			}
		}, 300);
	}

	customerHasStripeConflict = (customer, row) => {
		if (!customer?.stripe_id || !row?.stripe_customer_id) {
			return !!customer?.stripe_id;
		}
		return customer.stripe_id !== row.stripe_customer_id;
	}

	openLinkModal = (row) => {
		this.setState({
			linkModal: true,
			activeRow: row,
			customerSearch: '',
			searchResults: [],
			selectedCustomer: null,
			selectedAvKey: null,
			linkNotes: row.notes ?? '',
			actionError: null,
			searchLoading: false,
		}, () => this.loadSuggestedCustomer(row));
	}

	submitLink = async () => {
		const { activeRow, selectedCustomer, selectedAvKey, linkNotes } = this.state;
		if (!activeRow || !selectedCustomer?.pkey || !selectedAvKey) return;
		if (this.customerHasStripeConflict(selectedCustomer, activeRow)) {
			this.setState({ actionError: 'Selected customer already has a different Stripe customer ID on file.' });
			return;
		}
		this.setState({ actionError: null });
		try {
			let model = new API.BuildClass(Types.Stripe_Av_Unmatched._name, API.RequestType.UPDATE);
			model.object.pkey = activeRow.pkey;
			model.object.linked_customer = selectedCustomer.pkey;
			model.object.linked_av_key = selectedAvKey;
			model.object.notes = linkNotes;
			await model.submit(null, 'POST_MARK_LINKED');
			this.setState({ linkModal: false, activeRow: null });
			await this.fetchData();
		} catch (err) {
			this.setState({ actionError: err?.message || 'Link failed' });
		}
	}

	submitDismiss = async () => {
		const { activeRow, dismissalReason, dismissNotes } = this.state;
		if (!activeRow) return;
		if (!dismissalReason) {
			this.setState({ actionError: 'Please select a dismissal reason' });
			return;
		}
		this.setState({ actionError: null });
		try {
			let model = new API.BuildClass(Types.Stripe_Av_Unmatched._name, API.RequestType.UPDATE);
			model.object.pkey = activeRow.pkey;
			model.object.dismissal_reason = dismissalReason;
			model.object.notes = dismissNotes;
			await model.submit(null, 'POST_DISMISS');
			this.setState({ dismissModal: false, activeRow: null });
			await this.fetchData();
		} catch (err) {
			this.setState({ actionError: err?.message || 'Dismiss failed' });
		}
	}

	renderCustomerOption = (customer) => {
		const badges = [];
		if (customer.email_matches_stripe) badges.push('Email match');
		if (customer.has_active_av_key) badges.push('Has AV key');
		else badges.push('No AV key');
		if (customer.stripe_id_conflict || (customer.stripe_id && !this.state.activeRow?.stripe_customer_id)) {
			badges.push('Stripe ID conflict');
		} else if (customer.stripe_id) {
			badges.push(`Stripe: ${customer.stripe_id}`);
		}
		return `${customer.name} (${customer.email || 'no email'}) - ${badges.join(', ')}`;
	}

	renderSuggestedCustomer = (row) => {
		if (!row?.suggested_customer) {
			return '-';
		}
		const name = row.customers?.name
			|| row.customers_related_by_suggested_customer?.name
			|| `Customer #${row.suggested_customer}`;
		return (
			<Link to={`/customers/${row.suggested_customer}#av-center`}>{name}</Link>
		);
	}

	renderLinkStatus = (status) => {
		const labels = {
			unmatched: 'Unmatched',
			linked: 'Linked',
			dismissed: 'Dismissed',
		};
		return labels[status] || status || '-';
	}

	renderDismissalReason = (value) => {
		const match = DISMISSAL_REASONS.find(r => r.value === value);
		return match?.label || value || '-';
	}

	render() {
		const {data, pages, limit, loading, highlightRow} = this.state;
		const { activeRow, searchResults, selectedCustomer, linkStatusFilter, searchLoading } = this.state;
		const avKeys = selectedCustomer?.av_keys_summary || [];
		const selectedHasStripeConflict = selectedCustomer && activeRow
			? this.customerHasStripeConflict(selectedCustomer, activeRow)
			: false;

		const columns = [
			{
				Header: "Stripe Name",
				id: 'stripe_customer_name',
				accessor: obj => obj.stripe_customer_name || '-',
			},
			{
				Header: "Stripe Email",
				id: 'stripe_customer_email',
				accessor: obj => obj.stripe_customer_email || '-',
			},
			{
				Header: "Product",
				id: 'product_name',
				accessor: obj => obj.product_name,
			},
			{
				Header: "Status",
				id: 'stripe_status',
				accessor: obj => obj.stripe_status || 'N/A',
			},
			{
				Header: "Period End",
				id: 'period_end',
				accessor: obj => obj.period_end ? moment(obj.period_end).format('MM/DD/YYYY') : '',
			},
			{
				Header: "Cancel at End",
				id: 'cancel_at_period_end',
				accessor: obj => obj.cancel_at_period_end ? 'Yes' : 'No',
			},
			{
				Header: "Suggested",
				id: 'suggested',
				accessor: obj => {
					if (!obj.suggested_customer) return '-';
					return obj.customers?.name
						|| obj.customers_related_by_suggested_customer?.name
						|| `Customer #${obj.suggested_customer}`;
				},
				Cell: (props) => this.renderSuggestedCustomer(props.original),
			},
			{
				Header: "Link Status",
				id: 'link_status',
				accessor: obj => this.renderLinkStatus(obj.link_status),
				show: linkStatusFilter !== 'unmatched',
			},
			{
				Header: "Dismissal Reason",
				id: 'dismissal_reason',
				accessor: obj => this.renderDismissalReason(obj.dismissal_reason),
				show: linkStatusFilter === 'dismissed' || linkStatusFilter === 'all',
			},
			{
				Header: "",
				id: 'actions',
				show: linkStatusFilter === 'unmatched',
				Cell: (props) => {
					if (props.original.link_status && props.original.link_status !== 'unmatched') {
						return '-';
					}
					return (
					<span>
						<Button size="sm" color="primary" onClick={() => this.openLinkModal(props.original)} style={{ marginRight: 8 }}>
							Link
						</Button>
						<Button size="sm" color="secondary" onClick={() => this.setState({
							dismissModal: true,
							activeRow: props.original,
							dismissalReason: '',
							dismissNotes: props.original.notes ?? '',
							actionError: null,
						})}>
							Dismiss
						</Button>
					</span>
					);
				},
			},
		];

		return (
			<Card>
				<CardContent>
					{this.state.actionError && (
						<div className="alert alert-danger" role="alert">{this.state.actionError}</div>
					)}
					<div className="table-bar">
						<div className="d-flex align-items-center">
							<TextField
								select
								label="Link status"
								value={this.state.linkStatusFilter}
								onChange={(e) => this.setState({ linkStatusFilter: e.target.value }, () => this.fetchData())}
								margin="dense"
								style={{ minWidth: 180, marginRight: 16 }}
							>
								<MenuItem value="unmatched">Unmatched</MenuItem>
								<MenuItem value="linked">Linked</MenuItem>
								<MenuItem value="dismissed">Dismissed</MenuItem>
								<MenuItem value="all">All</MenuItem>
							</TextField>
							{this.renderSearch(SEARCH_LABEL)}
							{this.renderHeaderRight(SEARCH_LABEL, columns)}
						</div>
					</div>
					<ReactTable
						key={`${this.state.key}-${linkStatusFilter}`}
						columns={columns}
						manual
						data={data}
						pages={pages}
						loading={loading}
						loadingText="Requesting Data"
						onFetchData={this.fetchData}
						defaultSorted={[{ id: 'period_end', desc: true }]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						onPageChange={this.onPageChange}
						page={this.state.page}
						pageSize={limit}
						getTrProps={getCollectionHighlightTrProps(highlightRow, this.rowRefs)}
					/>
					<Framework.Elements.LoadingSpinner isLoading={loading}/>

					<Modal isOpen={this.state.linkModal} toggle={() => this.setState({ linkModal: false })} size="lg">
						<ModalHeader toggle={() => this.setState({ linkModal: false })}>Link Stripe Subscription to Customer</ModalHeader>
						<ModalBody>
							{this.state.actionError && (
								<div className="alert alert-danger" role="alert">{this.state.actionError}</div>
							)}
							{activeRow && (
								<div className="row">
									<div className="col-md-6">
										<h6>Stripe</h6>
										<p><strong>Name:</strong> {activeRow.stripe_customer_name || '-'}</p>
										<p><strong>Email:</strong> {activeRow.stripe_customer_email || '-'}</p>
										<p><strong>Customer ID:</strong> {activeRow.stripe_customer_id || '-'}</p>
										<p><strong>Product:</strong> {activeRow.product_name}</p>
										<p><strong>Status:</strong> {activeRow.stripe_status}</p>
										<p><strong>Period end:</strong> {activeRow.period_end ? moment(activeRow.period_end).format('MM/DD/YYYY') : '-'}</p>
									</div>
									<div className="col-md-6">
										<h6>Customer</h6>
										<TextField
											fullWidth
											margin="normal"
											label="Search customers"
											value={this.state.customerSearch}
											onChange={(e) => this.searchCustomers(e.target.value)}
											variant="outlined"
											helperText={searchLoading ? 'Searching…' : 'Type at least 2 characters'}
										/>
										<TextField
											select
											fullWidth
											margin="normal"
											label="Select customer"
											value={selectedCustomer?.pkey || ''}
											onChange={(e) => {
												const pkey = parseInt(e.target.value, 10);
												const match = searchResults.find(c => c.pkey === pkey);
												this.setState({ selectedCustomer: match || null, selectedAvKey: null });
											}}
											variant="outlined"
											InputLabelProps={{ shrink: true }}
										>
											<MenuItem value="">-</MenuItem>
											{searchResults.map(c => (
												<MenuItem
													key={c.pkey}
													value={c.pkey}
													disabled={this.customerHasStripeConflict(c, activeRow)}
												>
													{this.renderCustomerOption(c)}
												</MenuItem>
											))}
										</TextField>
										{selectedHasStripeConflict && (
											<p className="text-danger">This customer already has a Stripe customer ID and cannot be linked to this subscription.</p>
										)}
										{selectedCustomer && (
											<TextField
												select
												fullWidth
												margin="normal"
												label="AV key to link"
												value={this.state.selectedAvKey || ''}
												onChange={(e) => this.setState({ selectedAvKey: parseInt(e.target.value, 10) })}
												variant="outlined"
												InputLabelProps={{ shrink: true }}
											>
												<MenuItem value="">-</MenuItem>
												{avKeys.map(k => (
													<MenuItem key={k.pkey} value={k.pkey}>
														{k.product_name} - {k.activation_key?.substring(0, 12)}…
													</MenuItem>
												))}
											</TextField>
										)}
										{selectedCustomer && avKeys.length === 0 && (
											<p className="text-warning">No active AV key on this customer - create one in Sales first.</p>
										)}
										<TextField
											fullWidth
											margin="normal"
											multiline
											rows={4}
											label="Notes"
											value={this.state.linkNotes}
											onChange={(e) => this.setState({ linkNotes: e.target.value })}
											variant="outlined"
											InputLabelProps={{ shrink: true }}
										/>
									</div>
								</div>
							)}
						</ModalBody>
						<ModalFooter>
							<Button
								color="primary"
								disabled={!selectedCustomer?.pkey || !this.state.selectedAvKey || selectedHasStripeConflict}
								onClick={this.submitLink}
							>
								Link &amp; Sync
							</Button>
							<Button onClick={() => this.setState({ linkModal: false })}>Cancel</Button>
						</ModalFooter>
					</Modal>

					<Modal isOpen={this.state.dismissModal} toggle={() => this.setState({ dismissModal: false })} size="lg">
						<ModalHeader toggle={() => this.setState({ dismissModal: false })}>Dismiss Unmatched Row</ModalHeader>
						<ModalBody>
							<FormControl fullWidth variant="outlined" margin="normal">
								<InputLabel shrink htmlFor="dismissal-reason-select">Reason</InputLabel>
								<Select
									native
									value={this.state.dismissalReason}
									onChange={(e) => this.setState({ dismissalReason: e.target.value })}
									inputProps={{ id: 'dismissal-reason-select' }}
								>
									<option value="">Select a reason</option>
									{DISMISSAL_REASONS.map(r => (
										<option key={r.value} value={r.value}>{r.label}</option>
									))}
								</Select>
							</FormControl>
							{this.state.dismissalReason && (
								<p style={{ marginTop: 8, marginBottom: 0 }}>
									<strong>Selected:</strong> {this.renderDismissalReason(this.state.dismissalReason)}
								</p>
							)}
							<TextField
								fullWidth
								margin="normal"
								multiline
								rows={5}
								label="Notes"
								value={this.state.dismissNotes}
								onChange={(e) => this.setState({ dismissNotes: e.target.value })}
								variant="outlined"
								InputLabelProps={{ shrink: true }}
								placeholder="Optional details about why this row is being dismissed"
							/>
						</ModalBody>
						<ModalFooter>
							<Button color="primary" onClick={this.submitDismiss}>Dismiss</Button>
							<Button onClick={() => this.setState({ dismissModal: false })}>Cancel</Button>
						</ModalFooter>
					</Modal>
				</CardContent>
			</Card>
		);
	}
}
